import PropTypes from 'prop-types';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const PictureDefaultProps = {
  ...ClassNameDefaultProps,
  ...ChildrenDefaultProps,
  alt: '',
  altLoading: 'Chargement...',
  id: '',
  context: null,
  loader: null,
  observer: true,
  onError: () => null,
  onLoad: () => null,
  placeholder: null,
  rootMargin: '0px',
  src: null,
  srcSet: null,
  threshold: 0.1,
  type: null,
};

export const PicturePropTypes = {
  ...ClassNamePropTypes,
  ...ChildrenPropTypes,
  alt: PropTypes.string,
  altLoading: PropTypes.string,
  context: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loader: PropTypes.node,
  observer: PropTypes.bool,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  placeholder: PropTypes.node,
  rootMargin: PropTypes.string,
  src: PropTypes.string,
  srcSet: PropTypes.arrayOf(
    PropTypes.shape({ media: PropTypes.string, srcSet: PropTypes.string }),
  ),
  threshold: PropTypes.number,
  type: PropTypes.string,
};
